import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import { MatTooltipModule } from '@angular/material/tooltip';
import { TrackingRegistryView } from '../../services/list-individual.facade';

export type TrackingRegistryAction = 'edit' | 'delete' | 'toggleFavorite' | 'attributesEvolution';

@Component({
  selector: 'app-tracking-registry-actions',
  imports: [MatTooltipModule],
  templateUrl: './tracking-registry-actions.component.html',
  styleUrls: ['./tracking-registry-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrackingRegistryActionsComponent {
  @Input({ required: true }) item!: TrackingRegistryView;

  @Input() showAdminActions: boolean = false;
  @Input() isAlert30DaysWallet: boolean = false;

  @Output() actionClick = new EventEmitter<{
    action: TrackingRegistryAction;
    item: TrackingRegistryView;
  }>();

  onActionClick(action: TrackingRegistryAction): void {
    this.actionClick.emit({ action, item: this.item });
  }

  get favoriteIconClass(): string {
    return this.item.isFavorite ? 'fas fa-star' : 'far fa-star';
  }

  get favoriteTooltip(): string {
    return this.item.isFavorite
      ? $localize`:@@removeFavorites:Remover de favoritos`
      : $localize`:@@addFavorite:Agregar a favoritos`;
  }

  get editTooltip(): string {
    return $localize`:@@registerEdition:Editar Documento`;
  }

  get deleteTooltip(): string {
    return $localize`:@@deleteDocument:Excluir Documento`;
  }

  get attributesEvolutionTooltip(): string {
    return $localize`:@@viewTrendAnalysis:Ver análisis de tendencias`;
  }
}
